import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantAppOperation = {
  namespaced: true,

  state: () => ({
    allMerchantAppOperations: []
  }),

  getters: {
    _allMerchantAppOperations: state => state.allMerchantAppOperations
  },

  mutations: {
    ALL_MERCHANT_APP_OPERATIONS (state, data) {
      state.allMerchantAppOperations = data
    }
  },

  actions: {
    CreateMerchantAppOperation ({ rootState, dispatch }, { headers, data }) {
      /*
        {
          "merchantAppOperationName": "string",
          "merchantAppOperationCode": "string"
        }
      */
      return new Promise((resolve, reject) => {
        api.post('/MerchantAppOperation/CreateMerchantAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantAppOperation ({ rootState, dispatch }, { headers, data }) {
      /*
        {
          "merchantAppOperationID": 0,
          "merchantAppOperationName": "string",
          "merchantAppOperationCode": "string"
        }
      */
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantAppOperation/UpdateMerchantAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantMerchantAppOperation ({ rootState, dispatch }, { headers, data }) {
      /*
        {
          "merchantAppOperationID": 0
        }
      */
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantAppOperation​/DeleteMerchantMerchantAppOperation', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantAppOperation ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantAppOperation/GetAllMerchantAppOperation', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchantAppOperationByID ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantAppOperation/GetAllMerchantAppOperationByID?merchantid=${payload.merchantId}&merchatbeneficiarygroupID=${payload.merchatbeneficiarygroupID}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantAppOperation
